import { createStyles, makeStyles } from '@material-ui/core/styles';

type StyleProps = {
    hasOppositeContent?: true | false;
};

const oppositeContent = (hasOppositeContent: boolean | undefined) => {
    if (hasOppositeContent) {
        return {
            '&:before': {
                content: 'initial',
            },
        };
    }
};

const styles = ({ hasOppositeContent }: StyleProps) => {
    return createStyles({
        root: {
            ...oppositeContent(hasOppositeContent),
        },
    });
};

export default makeStyles(styles, { name: 'MuiTimelineItem' });
